
export class schedulerModel {
     jobType:number = 0;
     cronExpression: any;
     emailIds: any;
     userId: number= 0;
     active: boolean= false;
     jobData: any;
     scheduleType: number= 0;
     schedulerData: any;
     schedulerId: number=0;
     schedulerName?: string | null;
     startDate: Date | null = null;
     endDate: Date | null = null;
   //   cycle: any = null;
  }
